import api from './api';
import apiPublic from './apiPublic';

const PUBLIC = '/public';
const ADMIN = '/admin';

export const selectionProcessesPublic = {
  getBySlug: slug => apiPublic.get(`${PUBLIC}/selection_processes/${slug}`).then(r => r.data),

  listRegionals: slug => apiPublic.get(`${PUBLIC}/regionals`, { params: { selection_process_slug: slug } }).then(r => r.data),

  listInstitutions: regionalId => apiPublic.get(`${PUBLIC}/institutions`, { params: { regional_id: regionalId } }).then(r => r.data),

  submitRegistration: (slug, payload) => {
    const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
    const body = isFormData ? payload : { registration: payload };
    const config = isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined;
    return apiPublic.post(`${PUBLIC}/selection_processes/${slug}/registrations`, body, config).then(r => r.data);
  }
};

export const selectionProcessesAdmin = {
  list: (params = {}) => api.get(`${ADMIN}/selection_processes`, { params }),
  get: id => api.get(`${ADMIN}/selection_processes/${id}`),
  create: attrs => api.post(`${ADMIN}/selection_processes`, { selection_process: attrs }),
  update: (id, attrs) => api.patch(`${ADMIN}/selection_processes/${id}`, { selection_process: attrs }),
  destroy: id => api.delete(`${ADMIN}/selection_processes/${id}`),
  publish: id => api.post(`${ADMIN}/selection_processes/${id}/publish`),
  close: id => api.post(`${ADMIN}/selection_processes/${id}/close`),
  registrations: (id, params = {}) => api.get(`${ADMIN}/selection_processes/${id}/registrations`, { params }),
  registration: (id, registrationId) => api.get(`${ADMIN}/selection_processes/${id}/registrations/${registrationId}`),
  summary: id => api.get(`${ADMIN}/selection_processes/${id}/registrations/summary`),
  exportCsv: (id, params = {}) => api.get(`${ADMIN}/selection_processes/${id}/registrations/export.csv`, { params, responseType: 'blob' }),
  exportXlsx: (id, params = {}) => api.get(`${ADMIN}/selection_processes/${id}/registrations/export.xlsx`, { params, responseType: 'blob' }),
  questions: {
    list: id => api.get(`${ADMIN}/selection_processes/${id}/questions`),
    create: (id, q) => api.post(`${ADMIN}/selection_processes/${id}/questions`, { question: q }),
    update: (id, qId, q) => api.patch(`${ADMIN}/selection_processes/${id}/questions/${qId}`, { question: q }),
    destroy: (id, qId) => api.delete(`${ADMIN}/selection_processes/${id}/questions/${qId}`),
    reorder: (id, items) => api.patch(`${ADMIN}/selection_processes/${id}/questions/reorder`, { items })
  }
};
